/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { searchStates } from "../search/SearchConstants";
import { classicPDFSearchManager } from "search/ClassicPDFSearchManager";
import { getViewMode } from "selectors/viewModeSelectors";
import { isClassicPDF, getShouldUnblockUIFeatures } from "selectors/documentSelectors";
import { getShowSearchInTopbar } from "selectors/topbarSelectors";
import { getShowSearchInHUD } from "selectors/hudSelectors";

export const getShowSearchInputUI = stores =>
  stores.searchStore.showSearchInputUI && (getShowSearchInTopbar(stores) || getShowSearchInHUD(stores));
export const getShowSearchProgessBar = stores => stores.searchStore.showSearchProgessBar;
export const getShowNumberOfSearchResultsFound = stores => stores.searchStore.showNumberOfSearchResultsFound;
export const getPageBeingSearched = stores => stores.searchStore.pageBeingSearched;
export const getNumberOfSearchResultsInDocument = stores => stores.searchStore.numberOfSearchResultsInDocument;
export const getIndexOfCurrentSearchResult = stores => stores.searchStore.indexOfCurrentSearchResult;
export const getSearchState = stores => stores.searchStore.searchState;
export const getNumSearchWrapperComponentMounted = stores => stores.searchStore.numSearchWrapperComponentMounted;
export const getSearchInputClassName = stores => stores.searchStore.searchInputClassName;
export const getSearchWidgetClassName = stores => stores.searchStore.searchWidgetClassName;
export const getSearchInputStyle = stores => stores.searchStore.searchInputStyle;
export const getSearchWidgetStyle = stores => stores.searchStore.searchWidgetStyle;
export const getShouldshowSearchInHud = stores => stores.searchStore.shouldshowSearchInHud;
export const getCustomCss = stores => stores.searchStore.customCss;
export const shouldUseFullWidthOnTablet = stores => stores.searchStore.useFullWidthOnTablet;
export const getSearchQuery = stores => stores.searchStore.searchQuery;
export const getSearchAddOnPanel = stores => stores.searchStore.searchAddOnPanel;

export const isSearchInProgress = stores => {
  let result = false;
  if (
    getSearchState(stores) === searchStates.SEARCHING_FOR_FIRST_SEARCH_RESULT ||
    getSearchState(stores) === searchStates.SEARCHING_IN_BACKGROUND
  ) {
    result = true;
  }
  return result;
};

export const disablePreviousSearchButton = stores => {
  let viewMode = getViewMode(stores);
  if (isClassicPDF(stores)) {
    if (
      getNumberOfSearchResultsInDocument(stores) === 0 ||
      (getIndexOfCurrentSearchResult(stores) === 1 && isSearchInProgress(stores))
    ) {
      return true;
    }
    return false;
  }
};

export const disableNextSearchButton = stores => {
  let viewMode = getViewMode(stores);
  if (isClassicPDF(stores)) {
    if (
      (getIndexOfCurrentSearchResult(stores) === getNumberOfSearchResultsInDocument(stores) &&
        isSearchInProgress(stores)) ||
      getNumberOfSearchResultsInDocument(stores) === 0
    ) {
      return true;
    }
    return false;
  }
};

export const getDefaultSearchQuery = stores => stores.searchStore.defaultSearchQuery;

export const getSearchManager = stores => {
  let viewMode = getViewMode(stores);
  if (isClassicPDF(stores)) {
    return classicPDFSearchManager;
  }
};

export const getFirstSearchResultPromiseObj = stores => stores.searchStore.firstSearchResultPromiseObj;

export const getActiveSearchAPIObj = stores => stores.searchStore.activeSearchAPIObj;

export const enableSearchUI = stores => {
  if (
    getShouldUnblockUIFeatures(stores) &&
    isClassicPDF(stores) &&
    (getShowSearchInTopbar(stores) || getShowSearchInHUD(stores))
  ) {
    return true;
  }
  return false;
};
